// =============================================================================
// components/KpiRules/KpiRulesPage.jsx
// Pagina principal de gestao de regras KPI.
// =============================================================================
import { useEffect } from 'react';
import { Box, Grid, Paper, Typography, Button, Alert, Snackbar } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import TuneIcon from '@mui/icons-material/Tune';

import { useKpiRules } from '../../hooks/useKpi';
import KpiRuleList    from './KpiRuleList';
import KpiRuleForm    from './KpiRuleForm';
import EngineLog      from './EngineLog';

export default function KpiRulesPage() {
  const {
    items, loading,
    selectedRule, saving, saveError, saveSuccess,
    validation, rulesByTech,
    load, save, remove, select, openNew, validate, clearVal,
  } = useKpiRules();

  useEffect(() => { load(); }, []); // eslint-disable-line

  const handleCancel = () => { select(null); clearVal(); };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <TuneIcon color="primary" />
        <Typography variant="h5" fontWeight={700} sx={{ flex: 1 }}>
          Configuração de Regras KPI
        </Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={openNew}>
          Nova Regra
        </Button>
      </Box>

      <Grid container spacing={2}>
        {/* Coluna esquerda — lista */}
        <Grid item xs={12} md={5}>
          <Paper variant="outlined" sx={{ p: 2, maxHeight: '75vh', overflow: 'auto' }}>
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
              Regras Configuradas ({items.length})
            </Typography>
            {loading ? (
              <Typography variant="body2" color="text.secondary">A carregar...</Typography>
            ) : (
              <KpiRuleList
                rulesByTech={rulesByTech}
                selectedId={selectedRule?.kpiId}
                onSelect={select}
              />
            )}
          </Paper>
        </Grid>

        {/* Coluna direita — form + engine log */}
        <Grid item xs={12} md={7}>
          <Paper variant="outlined" sx={{ p: 3, mb: 2 }}>
            {selectedRule ? (
              <KpiRuleForm
                rule={selectedRule}
                saving={saving}
                saveError={saveError}
                validation={validation}
                onSave={save}
                onCancel={handleCancel}
                onValidate={validate}
                onDelete={remove}
              />
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  Selecione uma regra para editar ou clique em "Nova Regra".
                </Typography>
              </Box>
            )}
          </Paper>

          <EngineLog />
        </Grid>
      </Grid>

      <Snackbar
        open={saveSuccess}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity="success" variant="filled">Regra guardada com sucesso.</Alert>
      </Snackbar>
    </Box>
  );
}
